<div class="validation-message text-danger" *ngIf="showErrors">
    <ul style="display: block;">
        <li *ngFor="let e of errors">
            <label class="error">{{e}}</label>
        </li>
    </ul>
</div>
